/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            navigation.classList.remove('is-open');
            document.documentElement.style.overflowY = null;
        }
    });
})();

/* Live Trade Plan: match watchlist row from Morning Open + Noon Price */
(function () {
    var card = document.querySelector('[data-live-plan-card]');
    if (!card) return;

    var openInput = card.querySelector('[data-live-plan-open]');
    var noonInput = card.querySelector('[data-live-plan-noon]');
    var tierEl = card.querySelector('[data-live-plan-tier]');
    var entryUpperEl = card.querySelector('[data-live-plan-entry-upper]');
    var entryLowerEl = card.querySelector('[data-live-plan-entry-lower]');
    var tpEl = card.querySelector('[data-live-plan-tp]');
    var slEl = card.querySelector('[data-live-plan-sl]');
    var rrEl = card.querySelector('[data-live-plan-rr]');
    var profitEl = card.querySelector('[data-live-plan-profit]');
    var statusEl = card.querySelector('[data-live-plan-status]');
    var metaEl = card.querySelector('[data-live-plan-meta]');
    var contextEl = card.querySelector('[data-live-plan-context]');

    (function setContextFromTitle() {
        if (!contextEl) return;
        var titleEl = document.querySelector('.gh-article-title');
        if (!titleEl) return;
        var text = titleEl.textContent || '';
        var parts = text.split('·').map(function (p) { return p.trim(); }).filter(Boolean);
        /* Find date and ticker from parts (format-agnostic) */
        var date = '', ticker = '';
        for (var i = 0; i < parts.length; i++) {
            var p = parts[i];
            if (/^\d{4}-\d{2}-\d{2}$/.test(p)) { date = p; }
            else if (/^[A-Z]{1,5}$/.test(p)) { ticker = p; }
        }
        if (date && ticker) {
            contextEl.textContent = date + ' · ' + ticker;
        } else if (parts.length >= 2) {
            contextEl.textContent = parts.slice(0, 2).join(' · ');
        }
    })();

    function normalizeHeader(text) {
        return String(text || '')
            .toLowerCase()
            .replace(/[$%]/g, '')
            .replace(/\s+/g, ' ')
            .trim();
    }

    function findTable() {
        var setup = document.getElementById('setup');
        var setupTables = setup ? Array.from(setup.querySelectorAll('table')) : [];
        var target = setupTables.find(function (table) {
            var headers = getHeaderTexts(table);
            return headers.some(function (h) { return h.indexOf('morning open') !== -1; })
                && headers.some(function (h) { return h.indexOf('noon price') !== -1; });
        });
        if (target) return target;
        return document.querySelector('table.core-table');
    }

    function getHeaderTexts(table) {
        var ths = Array.from(table.querySelectorAll('thead th'));
        if (!ths.length) {
            var firstRow = table.querySelector('tr');
            ths = firstRow ? Array.from(firstRow.querySelectorAll('th, td')) : [];
        }
        return ths.map(function (cell) {
        var html = cell.innerHTML;
        var text = html.replace(/<br\s*\/?>/gi, ' ').replace(/<[^>]*>/g, '');
        return normalizeHeader(text);
    });
    }

    function findIndex(headers, keys) {
        for (var i = 0; i < headers.length; i += 1) {
            var h = headers[i];
            for (var k = 0; k < keys.length; k += 1) {
                if (h.indexOf(keys[k]) !== -1) return i;
            }
        }
        return -1;
    }

    function toNumber(text) {
        var cleaned = String(text || '').replace(/[^0-9.\-]/g, '');
        if (!cleaned) return NaN;
        return parseFloat(cleaned);
    }

    function formatMoney(value, fallback) {
        if (isFinite(value)) return '$' + value.toFixed(2);
        if (fallback) return fallback;
        return '--';
    }

    function trimText(text) {
        return String(text || '').replace(/\s+/g, ' ').trim();
    }

    function getCellText(cells, index) {
        if (index < 0 || index >= cells.length) return '';
        return trimText(cells[index].textContent);
    }

    var table = findTable();
    if (!table) {
        if (statusEl) statusEl.textContent = 'Waiting for watchlist table';
        if (metaEl) metaEl.textContent = 'Matched to bucket: --';
        return;
    }

    var headers = getHeaderTexts(table);
    if (!headers.length) {
        if (statusEl) statusEl.textContent = 'Waiting for watchlist table';
        if (metaEl) metaEl.textContent = 'Matched to bucket: --';
        return;
    }

    var indexes = {
        gapPct: findIndex(headers, ['gap']),
        morningTrend: findIndex(headers, ['morning trend', 'trend']),
        morningOpen: findIndex(headers, ['morning open']),
        noonPrice: findIndex(headers, ['noon price']),
        tier: findIndex(headers, ['tier']),
        direction: findIndex(headers, ['direction', 'action']),
        entryUpper: findIndex(headers, ['entry upper', 'entry high']),
        entryLower: findIndex(headers, ['entry lower', 'entry low']),
        takeProfit: findIndex(headers, ['take profit', 'tp']),
        stopLoss: findIndex(headers, ['stop loss', 'sl']),
        expectedProfit: findIndex(headers, ['expected profit', 'profit %']),
        riskReward: findIndex(headers, ['r:r', 'rr', 'risk reward']),
        breakevenAt: findIndex(headers, ['breakeven at', 'breakeven']),
        trailingPct: findIndex(headers, ['trailing', 'trailing']),
        horizonDays: findIndex(headers, ['horizon']),
        protectAfterDay: findIndex(headers, ['protect after day', 'pr'])
    };

    var bodyRows = Array.from((table.querySelector('tbody') || table).querySelectorAll('tr'));
    var rows = bodyRows.map(function (row) {
        var cells = row.querySelectorAll('td, th');
        var openText = getCellText(cells, indexes.morningOpen);
        var noonText = getCellText(cells, indexes.noonPrice);
        var openVal = toNumber(openText);
        var noonVal = toNumber(noonText);
        if (!isFinite(openVal) || !isFinite(noonVal)) return null;
        return {
            rowEl: row,
            gapPct: getCellText(cells, indexes.gapPct),
            morningTrend: getCellText(cells, indexes.morningTrend),
            morningOpen: openVal,
            noonPrice: noonVal,
            tier: getCellText(cells, indexes.tier),
            direction: getCellText(cells, indexes.direction),
            entryUpper: getCellText(cells, indexes.entryUpper),
            entryLower: getCellText(cells, indexes.entryLower),
            takeProfit: getCellText(cells, indexes.takeProfit),
            stopLoss: getCellText(cells, indexes.stopLoss),
            expectedProfit: getCellText(cells, indexes.expectedProfit),
            riskReward: getCellText(cells, indexes.riskReward),
            breakevenAt: getCellText(cells, indexes.breakevenAt),
            trailingPct: getCellText(cells, indexes.trailingPct),
            horizonDays: getCellText(cells, indexes.horizonDays)
        };
    }).filter(Boolean);

    if (!rows.length) {
        if (statusEl) statusEl.textContent = 'No watchlist rows available';
        if (metaEl) metaEl.textContent = 'Matched to bucket: --';
        return;
    }

    var activeRow = null;
    var activeHmCell = null;
    var freezeApplied = false;

    table.classList.add('gh-live-plan-target');

    function setCopyValues(entryUpper, entryLower, tp, sl) {
        card.dataset.copyEntryUpper = entryUpper || '';
        card.dataset.copyEntryLower = entryLower || '';
        card.dataset.copyTp = tp || '';
        card.dataset.copySl = sl || '';
    }

    function resetCard() {
        tierEl.textContent = '--';
        if (entryUpperEl) entryUpperEl.textContent = '--';
        if (entryLowerEl) entryLowerEl.textContent = '--';
        tpEl.textContent = '--';
        slEl.textContent = '--';
        rrEl.textContent = '--';
        if (profitEl) profitEl.textContent = '--';
        if (statusEl) statusEl.textContent = 'Waiting for inputs';
        if (metaEl) metaEl.textContent = 'Matched to bucket: --';
        setCopyValues('', '', '', '');
        window._livePlanMatch = null;
        if (typeof window._followUpUpdate === 'function') window._followUpUpdate();
        if (activeRow) {
            activeRow.classList.remove('is-live-plan');
            activeRow = null;
        }
        if (activeHmCell) {
            activeHmCell.classList.remove('is-live-plan-hm');
            activeHmCell = null;
        }
    }

    function highlightRow(row) {
        if (activeRow && activeRow !== row) {
            activeRow.classList.remove('is-live-plan');
        }
        activeRow = row;
        if (row) row.classList.add('is-live-plan');
    }

    function scrollToRow(row) {
        if (!row) return;
        var container = table.closest('.core-table-scroll');
        if (container && container.scrollHeight > container.clientHeight + 5) {
            var offset = row.offsetTop - container.clientHeight / 2 + row.clientHeight / 2;
            container.scrollTo({ top: offset, behavior: 'smooth' });
            return;
        }
        row.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    function highlightHmCell(gap, trend) {
        if (activeHmCell) {
            activeHmCell.classList.remove('is-live-plan-hm');
            activeHmCell = null;
        }
        if (!gap && gap !== '0' && gap !== 0) return;
        var gapNum = parseFloat(gap);
        var trendNum = parseFloat(trend);
        if (!isFinite(gapNum) || !isFinite(trendNum)) return;
        var gapStr = gapNum.toFixed(2);
        var trendStr = trendNum.toFixed(2);
        var cell = document.querySelector(
            '.hm-cell[data-hm-gap="' + gapStr + '"][data-hm-trend="' + trendStr + '"]'
        );
        if (!cell) {
            /* Fallback: parse title attribute for existing posts without data attrs */
            var allCells = document.querySelectorAll('.hm-cell');
            for (var i = 0; i < allCells.length; i++) {
                var title = allCells[i].getAttribute('title') || '';
                var m = title.match(/Gap:\s*([\-\d.]+).*Trend:\s*([\-\d.]+)/);
                if (m && parseFloat(m[1]).toFixed(2) === gapStr && parseFloat(m[2]).toFixed(2) === trendStr) {
                    cell = allCells[i];
                    break;
                }
            }
        }
        if (cell) {
            cell.classList.add('is-live-plan-hm');
            activeHmCell = cell;
        }
    }

    function applyStickyColumns() {
        if (freezeApplied || window.innerWidth < 1100) return;
        var indices = [indexes.entryUpper, indexes.entryLower, indexes.takeProfit, indexes.stopLoss]
            .filter(function (idx, pos, arr) { return idx >= 0 && arr.indexOf(idx) === pos; })
            .sort(function (a, b) { return b - a; });
        if (!indices.length) return;
        var headerCells = Array.from(table.querySelectorAll('thead th'));
        if (!headerCells.length) return;
        var widths = indices.map(function (idx) {
            var cell = headerCells[idx];
            return cell ? cell.getBoundingClientRect().width : 0;
        });
        var rightOffsets = [];
        var running = 0;
        for (var i = 0; i < widths.length; i += 1) {
            rightOffsets[i] = running;
            running += widths[i];
        }
        var rowsAll = Array.from(table.querySelectorAll('tr'));
        rowsAll.forEach(function (row) {
            var cells = row.querySelectorAll('th, td');
            indices.forEach(function (idx, i) {
                var cell = cells[idx];
                if (!cell) return;
                cell.classList.add('is-live-plan-sticky');
                cell.style.right = rightOffsets[i] + 'px';
            });
        });
        table.classList.add('gh-live-plan-freeze');
        freezeApplied = true;
    }

    function updateCard() {
        var openVal = parseFloat(openInput.value);
        var noonVal = parseFloat(noonInput.value);
        if (!isFinite(openVal) || !isFinite(noonVal)) {
            resetCard();
            return;
        }

        var best = null;
        var bestDist = Infinity;
        rows.forEach(function (row) {
            var dist = Math.abs(row.morningOpen - openVal) + Math.abs(row.noonPrice - noonVal);
            if (dist < bestDist) {
                bestDist = dist;
                best = row;
            }
        });

        if (!best) {
            resetCard();
            return;
        }

        var tier = trimText(best.tier);
        var direction = trimText(best.direction);
        var tierLine = tier && direction ? tier + ' / ' + direction : (tier || direction || '--');
        var entryUpper = trimText(best.entryUpper) || '--';
        var entryLower = trimText(best.entryLower) || '--';
        var takeProfit = trimText(best.takeProfit) || '--';
        var stopLoss = trimText(best.stopLoss) || '--';
        var expectedProfit = trimText(best.expectedProfit);
        var riskReward = trimText(best.riskReward);

        tierEl.textContent = tierLine;
        if (entryUpperEl) entryUpperEl.textContent = entryUpper;
        if (entryLowerEl) entryLowerEl.textContent = entryLower;
        tpEl.textContent = takeProfit;
        slEl.textContent = stopLoss;

        if (profitEl) profitEl.textContent = expectedProfit || '--';
        rrEl.textContent = riskReward || '--';

        setCopyValues(entryUpper, entryLower, takeProfit, stopLoss);
        if (statusEl) statusEl.textContent = 'Matched';
        if (metaEl) metaEl.textContent = 'Open=' + formatMoney(best.morningOpen) + ', Noon=' + formatMoney(best.noonPrice);

        highlightRow(best.rowEl);
        highlightHmCell(best.gapPct, best.morningTrend);
        scrollToRow(best.rowEl);
        applyStickyColumns();

        /* Expose matched row for Follow Up card */
        window._livePlanMatch = best;
        if (typeof window._followUpUpdate === 'function') window._followUpUpdate();
    }

    card.addEventListener('input', function (event) {
        if (event.target === openInput || event.target === noonInput) {
            updateCard();
        }
    });

    card.addEventListener('click', function (event) {
        var btn = event.target.closest('[data-live-plan-copy]');
        if (!btn) return;
        var key = btn.getAttribute('data-live-plan-copy');
        var arrowUp = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="display:inline-block;vertical-align:middle"><path d="M12 19V5"></path><path d="m5 12 7-7 7 7"></path></svg>';
        var arrowDn = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="display:inline-block;vertical-align:middle"><path d="M12 5v14"></path><path d="m19 12-7 7-7-7"></path></svg>';
        var labels = { 'entry-upper': 'Copy ' + arrowUp, 'entry-lower': 'Copy ' + arrowDn, tp: 'Copy TP', sl: 'Copy SL' };
        var value = '';
        if (key === 'entry-upper') value = card.dataset.copyEntryUpper || '';
        if (key === 'entry-lower') value = card.dataset.copyEntryLower || '';
        if (key === 'tp') value = card.dataset.copyTp || '';
        if (key === 'sl') value = card.dataset.copySl || '';
        if (!value) return;
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(value).then(function () {
                btn.textContent = 'Copied';
                setTimeout(function () { btn.innerHTML = labels[key] || 'Copy'; }, 1200);
            });
        }
    });

    if (rows.length && openInput && noonInput) {
        /* Use the baseline row as an illustrative placeholder, not as entered data. */
        var baselineRow = rows.find(function (r) {
            return parseFloat(r.gapPct) === 0 && parseFloat(r.morningTrend) === 0;
        }) || rows[0];
        openInput.placeholder = baselineRow.morningOpen.toFixed(2);
        noonInput.placeholder = baselineRow.noonPrice.toFixed(2);
        var fuEntry = document.querySelector('[data-followup-entry]');
        if (fuEntry) {
            fuEntry.placeholder = baselineRow.morningOpen.toFixed(2);
        }
    }

    resetCard();
})();

/* Follow Up card: breakeven / dynamic SL / exit date (Swing only) */
(function () {
    var fCard = document.querySelector('[data-followup-card]');
    if (!fCard) return;

    var entryInput = fCard.querySelector('[data-followup-entry]');
    var bestCloseInput = fCard.querySelector('[data-followup-bestclose]');
    var bestCloseHint = fCard.querySelector('[data-followup-bestclose-hint]');
    var bestCloseLabel = fCard.querySelector('[data-followup-bestclose-label]');
    var tierEl     = fCard.querySelector('[data-followup-tier]');
    var tpEl       = fCard.querySelector('[data-followup-tp]');
    var slEl       = fCard.querySelector('[data-followup-sl]');
    var beEl       = fCard.querySelector('[data-followup-be]');
    var dslEl      = fCard.querySelector('[data-followup-dsl]');
    var exitEl     = fCard.querySelector('[data-followup-exit-date]');
    var statusEl   = fCard.querySelector('[data-followup-status]');
    var metaEl     = fCard.querySelector('[data-followup-meta]');
    var contextEl  = fCard.querySelector('[data-followup-context]');

    /* Read signal date from bloom-meta */
    var bloomMeta = document.getElementById('bloom-meta');
    var signalDate = bloomMeta ? (bloomMeta.getAttribute('data-signal-date') || '') : '';

    function toNum(s) {
        var c = String(s || '').replace(/[^0-9.\-]/g, '');
        return c ? parseFloat(c) : NaN;
    }
    function fmt(v) { return isFinite(v) ? '$' + v.toFixed(2) : '--'; }

    /* Add N trading days (skip Sat/Sun) to a YYYY-MM-DD string */
    function addTradingDays(dateStr, n) {
        if (!dateStr || !isFinite(n) || n <= 0) return '--';
        var parts = dateStr.split('-');
        var d = new Date(parseInt(parts[0],10), parseInt(parts[1],10)-1, parseInt(parts[2],10));
        if (isNaN(d.getTime())) return '--';
        var added = 0;
        while (added < n) {
            d.setDate(d.getDate() + 1);
            var dow = d.getDay();
            if (dow !== 0 && dow !== 6) added++;
        }
        var yy = d.getFullYear();
        var mm = String(d.getMonth()+1).padStart(2,'0');
        var dd = String(d.getDate()).padStart(2,'0');
        return yy + '-' + mm + '-' + dd;
    }

    function resetFollowUp() {
        if (tierEl) tierEl.textContent = '--';
        if (tpEl)  tpEl.textContent = '--';
        if (slEl)  slEl.textContent = '--';
        if (beEl)  beEl.textContent = '--';
        if (dslEl) dslEl.textContent = '--';
        if (exitEl) exitEl.textContent = '--';
        if (bestCloseInput) bestCloseInput.value = '';
        if (statusEl) statusEl.textContent = 'Waiting for Live Trade Plan';
        if (metaEl) metaEl.textContent = 'Type your fill price after the order executes.';
    }

    function updateFollowUp() {
        var match = window._livePlanMatch;
        if (!match) { resetFollowUp(); return; }

        var entry = parseFloat(entryInput.value);
        var tp = toNum(match.takeProfit);
        var sl = toNum(match.stopLoss);
        var beAt = toNum(match.breakevenAt);
        var trail = toNum(match.trailingPct);
        var horizon = toNum(match.horizonDays);
        var tier = (match.tier || '').trim();
        var dir = (match.direction || '').trim();
        var tierLine = tier && dir ? tier + ' / ' + dir : (tier || dir || '--');
        /* Direction may be in its own column ("Long") or embedded in tier ("Trend Long") */
        var dirSource = (dir || tier).toUpperCase();
        var isLong = dirSource.indexOf('LONG') !== -1;

        /* Set context line */
        if (contextEl) {
            var sym = bloomMeta ? (bloomMeta.getAttribute('data-symbol') || '') : '';
            contextEl.textContent = sym ? sym + ' · ' + tierLine : tierLine;
        }

        /* Show tier, TP, SL from matched row regardless of entry */
        if (tierEl) tierEl.textContent = tierLine;
        if (tpEl)  tpEl.textContent = fmt(tp);
        if (slEl)  slEl.textContent = fmt(sl);

        if (!isFinite(entry)) {
            if (beEl)  beEl.textContent = '--';
            if (dslEl) dslEl.textContent = '--';
            if (exitEl) exitEl.textContent = '--';
            if (statusEl) statusEl.textContent = 'Enter your fill price';
            return;
        }

        /* Breakeven At ($): price where SL moves to entry */
        var bePrice = NaN;
        if (isFinite(beAt) && isFinite(tp)) {
            if (isLong) {
                bePrice = entry + beAt * (tp - entry);
            } else {
                bePrice = entry - beAt * (entry - tp);
            }
        }

        /* Dynamic Stop-Loss ($): trailing from best close */
        var bestClose = bestCloseInput ? parseFloat(bestCloseInput.value) : NaN;
        var dynSL = NaN;
        if (isFinite(trail) && isFinite(sl)) {
            if (isFinite(bestClose)) {
                /* Recalculate trailing stop from user-supplied best close */
                if (isLong && bestClose > entry) {
                    dynSL = entry + trail * (bestClose - entry);
                } else if (!isLong && bestClose < entry) {
                    dynSL = entry - trail * (entry - bestClose);
                }
                /* Trailing stop only tightens — never worse than original SL */
                if (isFinite(dynSL)) {
                    if (isLong && dynSL < sl) dynSL = sl;
                    if (!isLong && dynSL > sl) dynSL = sl;
                }
            }
            /* No best close entered (or not in profit): show original SL */
            if (!isFinite(dynSL)) dynSL = sl;
        }

        /* Update best-close label + hint with direction */
        if (bestCloseLabel) {
            bestCloseLabel.textContent = isLong
                ? 'Day Close: new high? ($)'
                : 'Day Close: new low? ($)';
        }
        if (bestCloseHint) {
            bestCloseHint.textContent = isLong
                ? 'Enter today\u2019s close \u2014 only tightens on new highs'
                : 'Enter today\u2019s close \u2014 only tightens on new lows';
        }

        if (beEl)  beEl.textContent = fmt(bePrice);
        if (dslEl) dslEl.textContent = fmt(dynSL);

        /* Exit date = signal_date + horizon trading days */
        var exitDate = addTradingDays(signalDate, horizon);
        if (exitEl) exitEl.textContent = exitDate;

        if (statusEl) statusEl.textContent = 'Calculated';
        if (metaEl) {
            var parts = [];
            if (isFinite(beAt)) parts.push('Breakeven fraction: ' + beAt);
            if (isFinite(trail)) parts.push('Trailing: ' + (trail*100).toFixed(0) + '%');
            if (isFinite(horizon)) parts.push('Horizon: ' + horizon + 'D');
            metaEl.textContent = parts.length ? parts.join(' · ') : '';
        }

        /* Layperson protection summary */
        var summaryEl = fCard.querySelector('[data-followup-summary]');
        if (!summaryEl) {
            summaryEl = document.createElement('div');
            summaryEl.setAttribute('data-followup-summary', '');
            summaryEl.className = 'gh-live-plan-explain';
            summaryEl.style.marginTop = '14px';
            var refNode = fCard.querySelector('.gh-live-plan-explain[data-followup-explain]');
            if (refNode) {
                refNode.parentNode.insertBefore(summaryEl, refNode);
            } else {
                fCard.appendChild(summaryEl);
            }
        }
        var longShort = isLong ? 'long' : 'short';
        var slAction = isLong ? 'drops to' : 'rises to';
        var tpAction = isLong ? 'reaches' : 'drops to';
        var beAction = isLong ? 'climbs to' : 'falls to';
        var lines = [];
        lines.push('<p class="gh-live-plan-explain-title">Your protection plan</p>');
        lines.push('<p>You entered at <strong>' + fmt(entry) + '</strong> (' + longShort + '). Set these levels in your broker now:</p>');
        if (isFinite(sl)) {
            lines.push('<p>\u2022 <strong>Stop-loss: ' + fmt(sl) + '</strong> — if the price ' + slAction + ' this level, exit immediately. This is your maximum loss.</p>');
        }
        if (isFinite(tp)) {
            lines.push('<p>\u2022 <strong>Take-profit: ' + fmt(tp) + '</strong> — if the price ' + tpAction + ' this level, take your gain and close.</p>');
        }
        if (isFinite(bePrice)) {
            lines.push('<p>\u2022 <strong>Breakeven trigger: ' + fmt(bePrice) + '</strong> — once the price ' + beAction + ' this level, move your stop-loss to ' + fmt(entry) + ' (your entry). From that point you cannot lose money on this trade.</p>');
        }
        if (isFinite(dynSL) && isFinite(sl) && Math.abs(dynSL - sl) > 0.005) {
            lines.push('<p style="background:rgba(255,165,0,0.12);border-left:3px solid #ffa500;padding:8px 12px;border-radius:4px;margin:8px 0;">\u26A0\uFE0F <strong>Dynamic stop-loss: ' + fmt(dynSL) + '</strong> — the trailing stop has tightened past your original stop (' + fmt(sl) + '). Update your broker stop to <strong>' + fmt(dynSL) + '</strong> now.</p>');
        } else if (isFinite(dynSL)) {
            lines.push('<p>\u2022 <strong>Trailing stop: ' + fmt(dynSL) + '</strong> \u2014 same as your original stop for now. After today\u2019s close, enter the closing price in the <em>Day Close</em> field above. If the stock closed in your favour, the Dynamic Stop-Loss will tighten automatically.</p>');
        }
        if (exitDate && exitDate !== '--') {
            lines.push('<p style="background:rgba(255,165,0,0.12);border-left:3px solid #ffa500;padding:8px 12px;border-radius:4px;margin:8px 0;">\u26A0\uFE0F <strong>Hard deadline: close by market close on ' + exitDate + '.</strong> If the stock hasn\u2019t hit your target or stop by then, close the position. The model does not apply past this date \u2014 holding longer means you are on your own.</p>');
        }
        summaryEl.innerHTML = lines.join('');

        /* Update the protect_trade guide step with a checklist */
        var protectStep = document.querySelector('[data-step-id="protect_trade"] .gh-guide-step-body');
        if (protectStep) {
            var ps = [];
            ps.push('<div style="display:flex;flex-direction:column;gap:6px;">');
            /* 1. Entry + SL + TP (set-and-forget) */
            var line1 = '\u2705 You entered at <strong>' + fmt(entry) + '</strong> (' + longShort + ')';
            if (isFinite(sl)) line1 += ' &nbsp;|&nbsp; Stop-loss <strong>' + fmt(sl) + '</strong>';
            if (isFinite(tp)) line1 += ' &nbsp;|&nbsp; Take-profit <strong>' + fmt(tp) + '</strong>';
            ps.push('<p style="margin:0;">' + line1 + '</p>');
            /* 2. Breakeven */
            if (isFinite(bePrice)) {
                ps.push('<p style="margin:0;">\u2B1C Move stop to <strong>' + fmt(entry) + '</strong> (entry) once price hits <strong>' + fmt(bePrice) + '</strong> (breakeven)</p>');
            }
            /* 3. Daily dSL check */
            ps.push('<p style="margin:0;">\u2B1C Check in every day \u2014 enter the closing price in <em>Trade Protection</em> to update your dynamic stop-loss</p>');
            /* 4. Hard deadline */
            if (exitDate && exitDate !== '--') {
                ps.push('<p style="margin:0;">\u26A0\uFE0F Close by <strong>' + exitDate + '</strong> if not already out</p>');
            }
            ps.push('</div>');
            var instrEl = protectStep.querySelector('.gh-guide-step-instruction');
            if (instrEl) instrEl.innerHTML = ps.join('');
            var nextEl = protectStep.querySelector('.gh-guide-step-meta');
            if (nextEl) nextEl.innerHTML = '<strong>Done:</strong> Protection levels are set. Move to the next step.';
        }
    }

    window._followUpUpdate = updateFollowUp;

    fCard.addEventListener('input', function (e) {
        if (e.target === entryInput) {
            entryInput.classList.remove('is-default');
            updateFollowUp();
        }
        if (e.target === bestCloseInput) {
            updateFollowUp();
        }
    });

    /* Copy buttons: SL / BE / dSL */
    var copyLabels = { be: 'Copy BE', dsl: 'Copy dSL' };
    fCard.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-followup-copy]');
        if (!btn) return;
        var key = btn.getAttribute('data-followup-copy');
        var el = key === 'be' ? beEl : key === 'dsl' ? dslEl : null;
        if (!el) return;
        var raw = (el.textContent || '').replace(/[^0-9.\-]/g, '');
        if (!raw) return;
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(raw).then(function () {
                btn.textContent = 'Copied';
                setTimeout(function () { btn.textContent = copyLabels[key] || 'Copy'; }, 1200);
            });
        }
    });

    /* Export Trade: copy all Live Trade Plan + Follow Up fields as TSV */
    var exportBtn = fCard.querySelector('[data-export-trade]');
    if (exportBtn) {
        exportBtn.addEventListener('click', function () {
            var match = window._livePlanMatch;
            if (!match) {
                exportBtn.textContent = 'No trade data';
                setTimeout(function () { exportBtn.textContent = 'Copy for Trade Journal'; }, 1500);
                return;
            }

            var sym = bloomMeta ? (bloomMeta.getAttribute('data-symbol') || '') : '';
            var sDate = signalDate || '';

            /* Read values from Live Trade Plan card */
            var lpCard = document.querySelector('[data-live-plan-card]');
            var lpOpen = lpCard ? (lpCard.querySelector('[data-live-plan-open]') || {}).value || '' : '';
            var lpNoon = lpCard ? (lpCard.querySelector('[data-live-plan-noon]') || {}).value || '' : '';

            /* Read Follow Up computed values */
            var fuEntry = entryInput ? entryInput.value || '' : '';
            var fuTier = tierEl ? tierEl.textContent : '';
            var fuTP = tpEl ? tpEl.textContent.replace(/[^0-9.\-]/g, '') : '';
            var fuSL = slEl ? slEl.textContent.replace(/[^0-9.\-]/g, '') : '';
            var fuBE = beEl ? beEl.textContent.replace(/[^0-9.\-]/g, '') : '';
            var fuDSL = dslEl ? dslEl.textContent.replace(/[^0-9.\-]/g, '') : '';
            var fuExit = exitEl ? exitEl.textContent : '';

            /* Parse tier/direction */
            var tierDir = (fuTier || '').split('/');
            var tier = (tierDir[0] || '').trim();
            var dir = (tierDir[1] || '').trim();

            var entryUpper = match.entryUpper || '';
            var entryLower = match.entryLower || '';
            var profit = match.expectedProfit || '';
            var rr = match.riskReward || '';
            var horizon = match.horizonDays || '';
            var breakeven = match.breakevenAt || '';
            var trailing = match.trailingPct || '';

            var headers = [
                'Source', 'Ticker', 'Signal Date',
                'Morning Open', 'Noon Price',
                'Tier + Direction',
                'Entry Upper', 'Entry Lower',
                'Take Profit', 'Stop Loss',
                'Expected Profit %', 'R:R',
                'Breakeven At', 'Trailing',
                'Entry (Actual)', 'Day Close',
                'Breakeven ($)', 'Dynamic SL ($)',
                'Exit Date', 'Horizon (D)'
            ];
            var fuBestClose = bestCloseInput ? bestCloseInput.value || '' : '';
            var values = [
                'Bloom Signals', sym, sDate,
                lpOpen, lpNoon,
                fuTier,
                entryUpper, entryLower,
                fuTP, fuSL,
                profit, rr,
                breakeven, trailing,
                fuEntry, fuBestClose,
                fuBE, fuDSL,
                fuExit, horizon
            ];

            var tsv = headers.join('\t') + '\n' + values.join('\t');

            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(tsv).then(function () {
                    exportBtn.textContent = 'Copied \u2713';
                    setTimeout(function () { exportBtn.textContent = 'Copy for Trade Journal'; }, 2000);
                });
            }
        });
    }

    /* Initial update if live plan already matched */
    updateFollowUp();
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Theme toggle (light/dark) */
(function () {
    const STORAGE_KEY = 'gh-theme';
    const root = document.documentElement;
    const buttons = document.querySelectorAll('[data-theme-toggle]');
    if (!buttons.length) return;

    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');

    function updateTvWidgetsTheme(mode) {
        const widgets = document.querySelectorAll(
            'tv-mini-chart, tv-ticker-tape, tv-ticker-tag, tv-symbol-info, tv-advanced-chart, tv-market-overview, tv-screener, tv-ticker'
        );
        widgets.forEach((widget) => {
            widget.setAttribute('color-theme', mode);
            widget.setAttribute('theme', mode);
            widget.setAttribute('data-theme', mode);
        });
    }

    function applyTheme(mode) {
        const isDark = mode === 'dark';
        root.setAttribute('data-theme', mode);
        root.classList.toggle('theme-dark', isDark);
        root.style.setProperty('--comments-text-color', isDark ? '#ffffff' : 'var(--color-primary-text)');
        root.style.setProperty('--comments-subtext-color', isDark ? 'rgba(255,255,255,0.7)' : 'var(--color-secondary-text)');
        document.querySelectorAll('.gh-comments').forEach((el) => {
            el.setAttribute('data-theme', mode);
            el.style.setProperty('--comments-text-color', isDark ? '#ffffff' : 'var(--color-primary-text)');
            el.style.setProperty('--comments-subtext-color', isDark ? 'rgba(255,255,255,0.7)' : 'var(--color-secondary-text)');
        });
        updateTvWidgetsTheme(mode);
        buttons.forEach((btn) => {
            btn.setAttribute('aria-label', isDark ? 'Activate light mode' : 'Activate dark mode');
            btn.setAttribute('title', isDark ? 'Activate light mode' : 'Activate dark mode');
            btn.setAttribute('aria-pressed', String(isDark));
        });
    }

    const stored = localStorage.getItem(STORAGE_KEY);
    const initial = stored === 'dark' || (!stored && prefersDark.matches) ? 'dark' : 'light';
    applyTheme(initial);

    buttons.forEach((btn) =>
        btn.addEventListener('click', () => {
            const next = root.classList.contains('theme-dark') ? 'light' : 'dark';
            localStorage.setItem(STORAGE_KEY, next);
            applyTheme(next);
        })
    );

    prefersDark.addEventListener('change', (event) => {
        const storedMode = localStorage.getItem(STORAGE_KEY);
        if (!storedMode) {
            applyTheme(event.matches ? 'dark' : 'light');
        }
    });
})();

/* TOC smooth scroll + active state (mobile + desktop) */
(function () {
    const OFFSET = 90;
    const buttons = Array.from(document.querySelectorAll('[data-target]'));
    if (!buttons.length) return;

    const sections = buttons
        .map((btn) => document.getElementById(btn.dataset.target || ''))
        .filter(Boolean);

    if (!sections.length) return;

    const setActive = (id) => {
        buttons.forEach((btn) => {
            const isActive = btn.dataset.target === id;
            btn.classList.toggle('is-active', isActive);
        });
    };

    buttons.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            const targetId = btn.dataset.target;
            const section = document.getElementById(targetId);
            if (!section) return;

            const rect = section.getBoundingClientRect();
            const top = rect.top + window.scrollY - OFFSET;
            window.scrollTo({ top, behavior: 'smooth' });
        });
    });

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                entry.target._isVisible = entry.isIntersecting;
            });
            /* Pick the topmost section that is currently visible */
            var topmost = null;
            var topY = Infinity;
            sections.forEach(function (sec) {
                if (sec._isVisible) {
                    var rect = sec.getBoundingClientRect();
                    if (rect.top < topY) { topY = rect.top; topmost = sec; }
                }
            });
            if (topmost) setActive(topmost.id);
        },
        { threshold: 0.05, rootMargin: '-80px 0px -40% 0px' }
    );

    sections.forEach((section) => observer.observe(section));
})();

/* TradingView mini-chart widgets for article cards */
(function () {
    // Load the tv-mini-chart web component library
    if (!document.querySelector('script[data-tv-mini-chart]')) {
        const script = document.createElement('script');
        script.type = 'module';
        script.src = 'https://widgets.tradingview-widget.com/w/en/tv-mini-chart.js';
        script.setAttribute('data-tv-mini-chart', 'true');
        document.head.appendChild(script);
    }

    // Wait for DOM and set symbols on each chart
    const init = () => {
        const SKIP_WORDS = new Set(['core','sheet','swing','intraday','edge']);
        const charts = document.querySelectorAll('.gh-tv-card-chart tv-mini-chart');
        charts.forEach(chart => {
            const container = chart.closest('.gh-tv-card-chart');
            const slug = container?.getAttribute('data-slug') || '';
            const title = container?.getAttribute('data-title') || '';
            let ticker = '';

            // Primary: extract ticker from slug segments (most stable)
            // Slug format: "2025-03-10-acn-swing-core" or "core-2025-03-10-acn"
            if (slug) {
                const segments = slug.split('-');
                for (const seg of segments) {
                    if (seg.length >= 1 && seg.length <= 5 && /^[a-z]+$/i.test(seg) && !SKIP_WORDS.has(seg.toLowerCase()) && !/^\d/.test(seg)) {
                        ticker = seg.toUpperCase();
                        break;
                    }
                }
            }

            // Fallback: extract from title parts
            if (!ticker && title) {
                const parts = title.split('\u00b7');
                for (const part of parts) {
                    const w = part.trim();
                    if (w.length >= 1 && w.length <= 5 && /^[A-Z]+$/.test(w)) {
                        ticker = w;
                        break;
                    }
                }
            }

            chart.setAttribute('symbol', ticker || 'AAPL');

            if (container) {
                container.classList.add('is-ready');
            }
        });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();

/* Coreopsis TradingView embed widgets (Live, Chart, Mood, Fundamentals) */
(function () {
    var frames = Array.from(document.querySelectorAll('.gh-core-tv-frame'));
    if (!frames.length) return;

    /* Resolve symbol: bloom-meta → bloom-chart JSON → post title → fallback AAPL */
    var metaEl = document.getElementById('bloom-meta');
    var symbol = '';
    var signalDate = '';

    if (metaEl) {
        symbol = (metaEl.getAttribute('data-symbol') || '').trim().toUpperCase();
        signalDate = (metaEl.getAttribute('data-signal-date') || '').trim();
    }

    if (!symbol) {
        var cfgEl = document.getElementById('bloom-chart');
        var cfg = {};
        if (cfgEl) {
            try { cfg = JSON.parse(cfgEl.textContent.trim() || '{}'); } catch (e) { cfg = {}; }
        }
        if (cfg.symbols) {
            symbol = Array.isArray(cfg.symbols) ? cfg.symbols[0] || '' : cfg.symbols;
        } else if (cfg.series && Array.isArray(cfg.series) && cfg.series[0] && cfg.series[0].symbol) {
            symbol = cfg.series[0].symbol;
        }
    }

    if (!symbol) {
        /* Parse ticker from post title — scan all segments for a valid ticker */
        var titleEl = document.querySelector('.gh-article-title');
        if (titleEl) {
            var parts = titleEl.textContent.split('\u00b7');
            for (var i = 0; i < parts.length; i++) {
                var w = parts[i].trim().toUpperCase();
                if (w.length >= 1 && w.length <= 5 && /^[A-Z]+$/.test(w) && !['CORE','SHEET','SWING'].includes(w)) {
                    symbol = w;
                    break;
                }
            }
        }
    }
    if (!symbol) symbol = 'NASDAQ:AAPL';

    /* ── Resolve signal date from bloom-meta or title ── */
    if (!signalDate) {
        (function () {
            var tEl = document.querySelector('.gh-article-title');
            if (!tEl) return;
            var m = tEl.textContent.match(/(\d{4}-\d{2}-\d{2})/);
            if (m) signalDate = m[1];
        })();
    }

    function getTheme() {
        return document.documentElement.classList.contains('theme-dark') ? 'dark' : 'light';
    }

    /* ── Bloom theme palette (keep in sync with screen.css) ── */
    var BLOOM = {
        bg:        '#0f1116',
        panel:     '#131821',
        border:    '#1c2129',
        text:      '#f5f7fb',
        textMuted: 'rgba(245,247,251,0.55)',
        green:     '#30cf43',
        red:       '#ff5252',
        gold:      '#e2c87a',
        steel:     '#7eb8d0'
    };

    /* Embed widget configs keyed by data-tv-widget */
    function widgetConfig(type, containerId) {
        var theme = getTheme();
        var base = {
            symbol: symbol,
            colorTheme: 'dark',
            isTransparent: true,
            locale: 'en',
            autosize: true
        };

        if (type === 'symbol-info') {
            return Object.assign({}, base, {
                width: '100%'
            });
        }
        if (type === 'advanced-chart') {
            return {
                symbol: symbol,
                theme: 'dark',
                locale: 'en',
                autosize: true,
                interval: '15',
                timezone: 'America/New_York',
                style: '1',
                allow_symbol_change: true,
                calendar: false,
                details: false,
                hide_top_toolbar: false,
                hide_side_toolbar: false,
                hide_legend: false,
                hide_volume: true,
                hotlist: false,
                save_image: true,
                withdateranges: false,
                watchlist: [],
                compareSymbols: [],
                studies: [],
                show_popup_button: true,
                popup_height: '550',
                popup_width: '800',
                backgroundColor: BLOOM.bg,
                gridColor: BLOOM.border,
                width: '100%',
                height: '100%',
                support_host: 'https://www.tradingview.com',
                overrides: {
                    /* Pane */
                    'paneProperties.background':     BLOOM.bg,
                    'paneProperties.backgroundType':  'solid',
                    'paneProperties.vertGridProperties.color': BLOOM.border,
                    'paneProperties.horzGridProperties.color': BLOOM.border,
                    /* Candles */
                    'mainSeriesProperties.candleStyle.upColor':         BLOOM.green,
                    'mainSeriesProperties.candleStyle.downColor':       BLOOM.red,
                    'mainSeriesProperties.candleStyle.borderUpColor':   BLOOM.green,
                    'mainSeriesProperties.candleStyle.borderDownColor': BLOOM.red,
                    'mainSeriesProperties.candleStyle.wickUpColor':     BLOOM.green,
                    'mainSeriesProperties.candleStyle.wickDownColor':   BLOOM.red,
                    /* Line / Area fallback */
                    'mainSeriesProperties.lineStyle.color':       BLOOM.green,
                    'mainSeriesProperties.areaStyle.linecolor':   BLOOM.green,
                    'mainSeriesProperties.areaStyle.color1': 'rgba(48, 207, 67, 0.28)',
                    'mainSeriesProperties.areaStyle.color2': 'rgba(48, 207, 67, 0.02)',
                    /* Scales */
                    'scalesProperties.lineColor':  BLOOM.border,
                    'scalesProperties.textColor':  BLOOM.text
                }
            };
        }
        if (type === 'technical-analysis') {
            return Object.assign({}, base, {
                interval: '1D',
                displayMode: 'single',
                showIntervalTabs: true,
                width: '100%',
                height: '100%'
            });
        }
        if (type === 'financials') {
            return Object.assign({}, base, {
                displayMode: 'regular',
                width: '100%',
                height: '100%'
            });
        }
        if (type === 'timeline') {
            return Object.assign({}, base, {
                feedMode: 'symbol',
                displayMode: 'regular',
                width: '100%',
                height: '100%'
            });
        }
        return null;
    }

    /* Script URLs for each widget type */
    var EMBED_URLS = {
        'symbol-info': 'https://s3.tradingview.com/external-embedding/embed-widget-symbol-info.js',
        'advanced-chart': 'https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js',
        'technical-analysis': 'https://s3.tradingview.com/external-embedding/embed-widget-technical-analysis.js',
        'financials': 'https://s3.tradingview.com/external-embedding/embed-widget-financials.js',
        'timeline': 'https://s3.tradingview.com/external-embedding/embed-widget-timeline.js'
    };

    function renderWidget(container) {
        var type = container.getAttribute('data-tv-widget');
        if (!type || !EMBED_URLS[type]) return;
        var config = widgetConfig(type);
        if (!config) return;

        /* Clear previous widget content (for theme re-render) */
        container.innerHTML = '';

        /* Advanced chart: use TradingView.widget() constructor for toolbar support */
        if (type === 'advanced-chart') {
            var mountId = 'tv-core-chart';
            container.id = mountId;
            config.container_id = mountId;
            /* Constructor needs explicit pixel height — percentages break */
            delete config.autosize;
            config.width = '100%';
            config.height = container.offsetHeight || 610;

            /* Compute timeframe: signal_date − 9 days → today */
            if (signalDate) {
                var sd = new Date(signalDate + 'T00:00:00Z');
                var from = new Date(sd.getTime() - 9 * 86400000);
                var now  = new Date();
                var days = Math.max(10, Math.round((now - from) / 86400000));
                config.timeframe = days + 'D';
            } else {
                config.timeframe = '1M';
            }

            var boot = function () {
                if (window.TradingView && typeof window.TradingView.widget === 'function') {
                    new window.TradingView.widget(config);
                }
            };
            var tvScript = document.querySelector('script[data-tv-loader]');
            if (window.TradingView && typeof window.TradingView.widget === 'function') {
                boot();
            } else if (tvScript) {
                tvScript.addEventListener('load', boot, { once: true });
            } else {
                var s = document.createElement('script');
                s.src = 'https://s3.tradingview.com/tv.js';
                s.async = true;
                s.setAttribute('data-tv-loader', 'true');
                s.addEventListener('load', boot, { once: true });
                document.body.appendChild(s);
            }
            return;
        }

        /* All other types: embed script approach */
        var wrapper = document.createElement('div');
        wrapper.className = 'tradingview-widget-container';
        wrapper.style.width = '100%';
        wrapper.style.height = '100%';

        var inner = document.createElement('div');
        inner.className = 'tradingview-widget-container__widget';
        inner.style.width = '100%';
        inner.style.height = '100%';
        wrapper.appendChild(inner);

        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = EMBED_URLS[type];
        script.async = true;
        script.textContent = JSON.stringify(config);
        wrapper.appendChild(script);

        container.appendChild(wrapper);
    }

    /* Initial render */
    frames.forEach(renderWidget);

    /* Re-render on theme toggle to pick up new colorTheme */
    var themeButtons = document.querySelectorAll('[data-theme-toggle]');
    themeButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
            /* Small delay so the theme class toggles first */
            setTimeout(function () { frames.forEach(renderWidget); }, 120);
        });
    });
})();

/* Panel collapse / expand toggle */
(function () {
    document.querySelectorAll('.gh-overview-inner .gh-overview-title').forEach(function (title) {
        title.addEventListener('click', function () {
            var inner = title.closest('.gh-overview-inner');
            if (!inner) return;
            inner.classList.toggle('is-collapsed');
        });
    });
})();

/* Share bar: Copy link + Native share */
(function () {
    /* Copy link to clipboard */
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-copy-link]');
        if (!btn) return;

        var url = btn.getAttribute('data-copy-link');
        var originalText = btn.querySelector('span') ? btn.querySelector('span').textContent : btn.textContent;

        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(url).then(function () {
                var span = btn.querySelector('span');
                if (span) {
                    span.textContent = 'Copied!';
                } else {
                    btn.textContent = 'Copied!';
                }
                setTimeout(function () {
                    if (span) {
                        span.textContent = originalText;
                    } else {
                        btn.textContent = originalText;
                    }
                }, 1500);
            });
        } else {
            // Fallback for older browsers
            var ta = document.createElement('textarea');
            ta.value = url;
            ta.style.position = 'fixed';
            ta.style.left = '-999999px';
            document.body.appendChild(ta);
            ta.select();
            try {
                document.execCommand('copy');
                var span = btn.querySelector('span');
                if (span) {
                    span.textContent = 'Copied!';
                } else {
                    btn.textContent = 'Copied!';
                }
                setTimeout(function () {
                    if (span) {
                        span.textContent = originalText;
                    } else {
                        btn.textContent = originalText;
                    }
                }, 1500);
            } catch (e) {
                console.error('Failed to copy:', e);
            }
            document.body.removeChild(ta);
        }
    });

    /* Native share (mobile) */
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-native-share]');
        if (!btn) return;

        if (!navigator.share) return; // Silently do nothing on unsupported browsers

        var title = btn.getAttribute('data-share-title') || document.title;
        var url = btn.getAttribute('data-share-url') || location.href;

        navigator.share({ title: title, url: url }).catch(function (err) {
            // User cancelled or error occurred, silently handle
            console.debug('Share cancelled:', err);
        });
    });
})();

/* Coreopsis: relocate post-body elements into theme mount points.
 *
 * build_post.py embeds these elements inside Ghost's {{content}} block
 * (rendered into .js-post-content).  The theme template defines empty
 * <div id="core-*-mount"> targets above the post body; this IIFE moves
 * each source element from .js-post-content into its designated mount.
 *
 * Ghost's ?source=html API strips outer <div> wrappers around <table>
 * elements during Lexical conversion.  For those two sections we fall
 * back to the surviving inner element and re-wrap it in the expected
 * class before moving, so CSS rules continue to apply correctly:
 *
 *   .core-heatmap    → inner: .hm-table       → re-wrap div.core-heatmap
 *   .core-table-shell → inner: #core-scroll   → re-wrap div.core-table-shell
 *
 * All other sections produce non-table HTML that Ghost preserves verbatim
 * and can be moved directly.
 */
(function () {
    /* helper: wrap el in a new <div class=cls> in-place and return wrapper */
    function rewrap(el, cls) {
        var w = document.createElement('div');
        w.className = cls;
        el.parentNode.insertBefore(w, el);
        w.appendChild(el);
        return w;
    }

    /* simple moves – elements that survive Ghost's Lexical conversion */
    var moves = [
        { src: '.core-exit-info',     dst: 'core-exit-mount' },
        { src: '.core-legend',        dst: 'core-legend-mount' },
        { src: '.core-provenance',    dst: 'core-provenance-mount' },
    ];
    moves.forEach(function (m) {
        var el = document.querySelector(m.src);
        var mount = document.getElementById(m.dst);
        if (el && mount) { mount.appendChild(el); }
    });

    /* Ticker Technicals – Ghost strips outer div.core-ticker-tech around the
       table; fall back to <table class="core-msa core-msa--tech"> and re-wrap */
    var tMount = document.getElementById('core-ticker-mount');
    if (tMount) {
        var tickerTech = document.querySelector('.core-ticker-tech');
        if (!tickerTech) {
            var techTable = document.querySelector('.core-msa--tech');
            if (techTable) { tickerTech = rewrap(techTable, 'core-ticker-tech'); }
        }
        if (tickerTech) { tMount.appendChild(tickerTech); }
    }

    /* Sector / Industry – Ghost strips outer div.core-market-sector around the
       table; fall back to <table class="core-msa core-msa--sector"> and re-wrap */
    var sMount = document.getElementById('core-sectors-mount');
    if (sMount) {
        var sectors = document.querySelector('.core-market-sector');
        if (!sectors) {
            var sectorTable = document.querySelector('.core-msa--sector');
            if (sectorTable) { sectors = rewrap(sectorTable, 'core-market-sector'); }
        }
        if (sectors) { sMount.appendChild(sectors); }
    }

    /* Bloom Profile – outer div.core-heatmap is stripped by Ghost;
       fall back to the surviving <table class="hm-table"> and re-wrap */
    var bMount = document.getElementById('core-bloom-mount');
    if (bMount) {
        var heatmap = document.querySelector('.core-heatmap');
        if (!heatmap) {
            var hmTable = document.querySelector('.hm-table');
            if (hmTable) { heatmap = rewrap(hmTable, 'core-heatmap'); }
        }
        if (heatmap) { bMount.appendChild(heatmap); }
    }

    /* Watchlist – Ghost strips ALL outer divs around tables, so both
       div.core-table-shell and div.core-table-scroll are absent; fall back
       to the surviving <table class="core-table"> and re-wrap both layers so
       CSS max-height / overflow-y scroll rules apply correctly */
    var wMount = document.getElementById('core-watchlist-mount');
    if (wMount) {
        var shell = document.querySelector('.core-table-shell');
        if (!shell) {
            var coreTable = document.querySelector('.core-table');
            if (coreTable) {
                var scroll = rewrap(coreTable, 'core-table-scroll');
                scroll.id = 'core-scroll'; /* restore id for centerScroll() */
                shell = rewrap(scroll, 'core-table-shell');
            }
        }
        if (shell) { wMount.appendChild(shell); }
    }
})();
